<template>
    <div class="signup">

        <div class="mt-25">
        <h3>Stap 1/2: email & wachtwoord instellen</h3>
        <input type="text" placeholder="email adres" v-model="email"><br>
        <input type="password" placeholder="wachtwoord" v-model="password"><br>
        <button @click="signup">registreren</button>
    </div>
    </div>
</template>


<script>
import firebase from 'firebase';
export default {
    name: 'signup',
    data() {
        return {
            email: '',
            password: '',
        };
    },
    methods: {
        
        signup: function() {
            let th = this
           firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
           .then( function() {
                th.$router.replace('/register');
           },
           function (error){
               alert("error!" + error.message);
               // TODO als al bestaat in users dan ... ja wat dan?
           });
        }
    }
}
</script>


<style scoped>
signup {
    margin-top: 40px;
}
input {
    margin: 10px 0;
    width: 20%;
    padding: 15px;
}
button {
    margin-top: 20px;
    width: 10%;
    cursor: pointer;
}
p {
    margin-top: 40px;
    font-size:  13px;
}
p a {
    text-decoration: underline;
    cursor: pointer;
}
</style>